import { useQuery } from '@tanstack/react-query';

import { getUserAvatarUrlsV2QueryOptions } from '@/services/getUserAvatarUrlsV2';
import { getAvatarUrl } from '@/util/getAvatarUrl';

/**
 * Hook to fetch and resolve an expert's avatar URL
 *
 * @param expertId - The expert's user ID
 * @returns The resolved avatar URL or undefined if not available
 */
export function useExpertAvatar(expertId: number) {
  const { data: avatarData } = useQuery(getUserAvatarUrlsV2QueryOptions([expertId]));

  const expertAvatar = avatarData?.userAvatarUrlLookup.get(expertId);

  return getAvatarUrl(expertAvatar);
}
